import {Injectable} from '@angular/core';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {NavService} from './nav-service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PublipostageModelesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  editionMail = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PUBLIPOSTAGE_MODELES,
    EparcoursPath.publipostageModele.EDITION_MAIL,
  );
  creationModeleMail = this.makeNavigator(
    EparcoursPath.root.PUBLIPOSTAGE_MODELES,
    EparcoursPath.publipostageModele.CREATION_MAIL,
  );
  creationModeleCourrier = this.makeNavigator(
    EparcoursPath.root.PUBLIPOSTAGE_MODELES,
    EparcoursPath.publipostageModele.CREATION_COURRIER,
  );

  editionCourrier = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PUBLIPOSTAGE_MODELES,
    EparcoursPath.publipostageModele.EDITION_COURRIER,
  );
  liste = this.makeNavigator(EparcoursPath.root.PUBLIPOSTAGE_MODELES);
}
